import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-943027c8")

_pushScopeId("data-v-943027c8")
const _hoisted_1 = { class: "p-d-flex p-flex-row p-jc-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Tree = _resolveComponent("Tree")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.knParameterTreeDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.parameter') + ': ' + _ctx.parameter?.label), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.save
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Tree, {
        id: "kn-parameter-tree",
        value: _ctx.nodes,
        selectionMode: !_ctx.multivalue ? 'single' : null,
        selectionKeys: _ctx.selectedValuesKeys,
        "onUpdate:selectionKeys": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedValuesKeys = $event)),
        metaKeySelection: false,
        onNodeSelect: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setSelectedValue($event))),
        onNodeUnselect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeSelectedValue($event))),
        onNodeExpand: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadLeaf($event))),
        onNodeCollapse: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setClosedFolderIcon($event)))
      }, {
        default: _withId((slotProps) => [
          (_ctx.multivalue && slotProps.node.selectable)
            ? (_openBlock(), _createBlock(_component_Checkbox, {
                key: 0,
                class: "p-ml-2",
                modelValue: _ctx.selectedNodes,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedNodes = $event)),
                value: slotProps.node.data,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onNodeChange($event)))
              }, null, 8, ["modelValue", "value"]))
            : _createCommentVNode("", true),
          _createVNode("span", null, _toDisplayString(slotProps.node.label), 1)
        ]),
        _: 1
      }, 8, ["value", "selectionMode", "selectionKeys"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
})